export const ConfigMixin = {
  data() {
    return {
      osvConfig: window.__osvConf
    };
  }
};
